/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { subscribeToList } from "@eisinc/App/Services/EmailService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ExecuteOnSuccessCallback,
    SendDataToApi,
} from "@insite/client-framework/Store/CommonHandlers/Subscribe";

replaceInChain(chain, SendDataToApi, async props => {
    try {
        await subscribeToList(props.apiParameter);
    } catch (error) {
        (props.parameter as any).isError = true;
    }
});

replaceInChain(chain, ExecuteOnSuccessCallback, props => {
    if ((props.parameter as any).isError) {
        (props.parameter as any).onFail?.();
    } else {
        props.parameter.onSuccess?.();
    }

    (props.parameter as any).isError = false;
});
